(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  $('.home-blog-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
      }
    },
    {
      breakpoint: 600,
      settings: {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
   $('.cust-content.cust-active').slick({
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '150px',
            infinite: true
        }
      },
      {
        breakpoint: 769,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          slidesToShow: 1, 
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: true
        }
      }
    ]
  });
  
  } catch(e) { console.error(e); }
})();
})();
